import type { TemplateRegistry } from "@assets/templates/types";

import { aerialFieldDetectExample } from "./aerial-field-detect-example";
import { aerialViewExample } from "./aerial-view-example";
import { agricultureFruits } from "./agriculture-fruits-example";
import { agricultureWeeds } from "./agriculture-weeds-example";
import { ambulanceSirenExample } from "./ambulance-siren-example";
import { buildingFireExample } from "./building-fire-example";
import { clocksExample } from "./clocks-example";
import { convPointingDemoExample } from "./conv-pointing-demo-example";
import { cookingVideoExample } from "./cooking-video-example";
import { deskDetectExample } from "./desk-detect-example";
import { discordTicketExample } from "./discord-ticket-example";
import { drivingPovDetectExample } from "./driving-pov-detect-example";
import { emptyParkingDetectExample } from "./empty-parking-detect-example";
import { factoryFloorVideoExample } from "./factory-floor-video-example";
import { findTeaPotExample } from "./find-tea-pot-example";
import { forkliftDetectExample } from "./forklift-detect-example";
import { freewayDetectExample } from "./freeway-detect-example";
import { fruitDetectExample } from "./fruit-detect-example";
import { golfSwingExample } from "./golf-swing-example";
import { humanoidVideoExample } from "./humanoid-video-example";
import { iphoneScreenshotExample } from "./iphone-screenshot-example";
import { javelinVideoExample } from "./javelin-video-example";
import { jumpShotExample } from "./jump-shot-example";
import { licensePlateExample } from "./license-plate-example";
import { manufacturingExample } from "./manufacturing-example";
import { manyObjectPointingExample } from "./many-object-pointing-example";
import { parkingLotExample } from "./parking-lot-example";
import { powerLineDetectExample } from "./power-line-detect-example";
import { ppeDetectionExample } from "./ppe-detection-example";
import { preShipmentInspectionExample } from "./pre-shipment-inspection-example";
import { rockClimbingDetectExample } from "./rock-climbing-detect-example";
import { smokeDetectExample } from "./smoke-detect-example";
import { soccerVideoExample } from "./soccer-video-example";
import { solarInspectionExample } from "./solar-inspection-example";
import { sportsReplayVideoExample } from "./sports-replay-video-example";
import { teaDetectExample } from "./tea-detect-example";
import { tennisRallyExample } from "./tennis-rally-example";
import { treeTreatmentExample } from "./tree-treatment-example";
import { vqaDemoExample } from "./vqa-demo-example";
import { wildlifePtarmiganDetectExample } from "./wildlife-ptarmigan-detect-example";
import { wildlifeSnakeDetectExample } from "./wildlife-snake-detect-example";

export const TEMPLATE_REGISTRY: TemplateRegistry = {
  templates: [
    treeTreatmentExample,
    tennisRallyExample,
    preShipmentInspectionExample,
    ambulanceSirenExample,
    manyObjectPointingExample,
    convPointingDemoExample,
    manufacturingExample,
    vqaDemoExample,
    findTeaPotExample,
    solarInspectionExample,
    ppeDetectionExample,
    agricultureWeeds,
    agricultureFruits,
    discordTicketExample,
    iphoneScreenshotExample,
    factoryFloorVideoExample,
    sportsReplayVideoExample,
    cookingVideoExample,
    clocksExample,
    soccerVideoExample,
    javelinVideoExample,
    licensePlateExample,
    humanoidVideoExample,
    golfSwingExample,
    jumpShotExample,
    aerialViewExample,
    buildingFireExample,
    parkingLotExample,
    emptyParkingDetectExample,
    powerLineDetectExample,
    aerialFieldDetectExample,
    rockClimbingDetectExample,
    deskDetectExample,
    freewayDetectExample,
    drivingPovDetectExample,
    fruitDetectExample,
    smokeDetectExample,
    teaDetectExample,
    forkliftDetectExample,
    wildlifePtarmiganDetectExample,
    wildlifeSnakeDetectExample,
  ],
};
